import React from 'react';

const ProcessButton = ({ 
  processing, 
  formData, 
  annotatedImageFiles, 
  onProcessDocuments,
  successfulSubmit 
}) => {
  const isDisabled = processing || 
                    !formData.supplierName.trim() ||
                    (formData.annotatedImages && annotatedImageFiles.length === 0) ||
                    successfulSubmit;

  return (
    <div className="form-card action-card">
      <div className="card-content">
        <button
          className="process-btn"
          onClick={onProcessDocuments}
          disabled={isDisabled}
        >
          {successfulSubmit ? (
            <>
              <span className="btn-icon">✅</span>
              <span>Supplier Added Successfully!</span>
            </>
          ) : processing ? (
            <>
              <span className="spinner">⏳</span>
              <span>Processing Data...</span>
            </>
          ) : (
            <>
              <span className="btn-icon">🚀</span>
              <span>Add Supplier</span>
            </>
          )}
        </button>
        
        <div className="process-info">
          <span>🏢 Supplier: {formData.supplierName || 'Not specified'}</span>
          {formData.annotatedImages && annotatedImageFiles.length > 0 && (
            <span>🖼️ {annotatedImageFiles.length} image{annotatedImageFiles.length !== 1 ? 's' : ''} selected</span>
          )}
          {formData.annotatedImages && annotatedImageFiles.length === 0 && (
            <span>⚠️ No images selected (required for annotated processing)</span>
          )}
          {!formData.annotatedImages && (
            <span>📝 Text-only processing</span>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProcessButton;